export const PILLAR_TASK_STATUS = {
    NOT_STARTED: 'not_started',
    STARTED: 'started',
    UNDER_REVIEW: 'under_review',
    COMPLETED: 'completed',
    REJECTED: 'rejected',
    PENDING: 'pending',
};

export const mockUsers = [
    { id: 'u1', name: 'Eyob Zekariyas' },
    { id: 'u2', name: 'Robel Kebede' },
    { id: 'u3', name: 'Yared user' },
    { id: 'u4', name: 'Mintesnot user' },
    { id: 'u5', name: 'Kwame Asare' },
];

const today = new Date('2026-03-19T00:00:00Z');

function isoDaysFromToday(days) {
    const d = new Date(today);
    d.setUTCDate(d.getUTCDate() + days);
    return d.toISOString().slice(0, 10);
}

export const mockProjects = [
    {
        id: 'project1',
        description: 'Improve renewable energy integration across priority regions.',
        startDate: isoDaysFromToday(-30),
        endDate: isoDaysFromToday(10),
        isActive: true,
        tasks: [
            {
                id: 't1',
                projectId: 'project1',
                name: 'Solar uptake roadmap',
                description: 'Develop a roadmap for solar adoption, focusing on grid readiness and financing.',
                startDate: isoDaysFromToday(-20),
                endDate: isoDaysFromToday(8),
                priority: 3,
                status: PILLAR_TASK_STATUS.UNDER_REVIEW,
                assignedUsers: [
                    { userId: 'u1', name: 'Amina Abdullahi', isChair: true },
                    { userId: 'u2', name: 'Kojo Mensah', isChair: false },
                ],
                submissions: [
                    {
                        id: 'sub1',
                        date: isoDaysFromToday(-5),
                        status: 'pending',
                        evidence: ['solar_roadmap_v1.pdf'],
                        feedback: null,
                        progressPercent: 60,
                    },
                ],
                chat: [
                    { id: 'm1', from: 'member', text: 'Evidence uploaded; waiting for review.', date: isoDaysFromToday(-5) },
                    { id: 'm2', from: 'chair', text: 'Thanks. Please check assumptions in financing section.', date: isoDaysFromToday(-4) },
                ],
            },
            {
                id: 't2',
                projectId: 'project1',
                name: 'Grid readiness checklist',
                description: 'List key grid readiness requirements for integration at scale.',
                startDate: isoDaysFromToday(-12),
                endDate: isoDaysFromToday(3),
                priority: 2,
                status: PILLAR_TASK_STATUS.STARTED,
                assignedUsers: [{ userId: 'u3', name: 'Fatima Hassan', isChair: false }],
                submissions: [],
                chat: [],
            },
        ],
    },
    {
        id: 'project2',
        description: 'Strengthen climate adaptation measures for water security.',
        startDate: isoDaysFromToday(-15),
        endDate: isoDaysFromToday(25),
        isActive: true,
        tasks: [
            {
                id: 't3',
                projectId: 'project2',
                name: 'Water security action plan',
                description: 'Develop action plan with adaptation measures and monitoring indicators.',
                startDate: isoDaysFromToday(-10),
                endDate: isoDaysFromToday(20),
                priority: 3,
                status: PILLAR_TASK_STATUS.COMPLETED,
                assignedUsers: [{ userId: 'u4', name: 'Elena Rossi', isChair: false }],
                submissions: [
                    {
                        id: 'sub2',
                        date: isoDaysFromToday(-2),
                        status: 'approved',
                        evidence: ['water_action_plan_final.pdf'],
                        feedback: 'Approved: comprehensive and actionable.',
                        progressPercent: 100,
                    },
                ],
                chat: [{ id: 'm3', from: 'chair', text: 'Approved. Great work!', date: isoDaysFromToday(-2) }],
            },
        ],
    },
];

